<div class="app-body tw-relative">
  @if (!store.isIframe()) {
    <app-header class="header" />
  }
  <div class="tw-flex tw-relative">
    @if (!store.sideNavHide() && !store.isIframe()) {
      <app-sidenav
        [app]="{ name: 'GST Compliance', icon: 'matReceiptLongOutline' }"
        [menu]="sidenavMenu"
        [search]="false"
      />
    }
    <div
      class="tw-flex-1 tw-min-w-0"
      [class]="store.isIframe() ? 'page-wrapper !tw-py-4' : 'page-wrapper'"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
